import { Core } from 'chessboard/core/config/types';
import { is } from 'src/utils/app/model/is';
import type { Markings } from 'chessboard/plugins/markings/config/types';

/**
 * Determine if it's a Mark event of a specific type. It's a curried function
 * designed to be used as a helper in the `condition` property of a `match`.
 */
export function isMark(type: string) {
  return function isMarkingOfType(event: Core.Event) {
    return (
      is(Core.APIEvents.Mark)(event) &&
      event.data.find?.((marking: Markings.Model) => marking.type === type)
    );
  };
}
